module.exports = __webpack_public_path__ + "img/full_screen.c5b494e2.svg";